import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { KeyRound, X } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export function ChangePassword({ authHeaders }) {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (next.length < 6) return toast.error('New password minimum 6 characters வேணும்');
    if (next !== confirm) return toast.error('New password rendum match ஆகல');
    setBusy(true);
    try {
      await axios.post(
        `${API}/api/auth/change-password`,
        { current_password: current, new_password: next },
        { headers: authHeaders() }
      );
      toast.success('Password change ஆயிடுச்சு! அடுத்த login-ல new password use பண்ணுங்க');
      setOpen(false);
      setCurrent('');
      setNext('');
      setConfirm('');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Password change failed');
    } finally {
      setBusy(false);
    }
  };

  const field = (label, value, setter, testid) => (
    <label className="block">
      <span className="mb-1 block text-[11px] uppercase tracking-[0.2em] text-[#A3A3A3]">{label}</span>
      <input
        type="password"
        value={value}
        onChange={(e) => setter(e.target.value)}
        data-testid={testid}
        className="w-full border border-white/15 bg-black/60 px-3 py-2.5 text-white outline-none focus:border-[#F5C542]"
      />
    </label>
  );

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="change-password-open"
        className="flex items-center gap-2 border border-white/20 px-4 py-2 text-xs uppercase tracking-[0.15em] text-white hover:border-[#F5C542] hover:text-[#F5C542]"
      >
        <KeyRound className="h-3.5 w-3.5" /> Password
      </button>
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" data-testid="change-password-modal">
          <div className="w-full max-w-sm border border-[#F5C542]/30 bg-[#0A160D] p-6">
            <div className="mb-5 flex items-center justify-between">
              <h3 className="font-display text-sm uppercase tracking-[0.2em] text-[#F5C542]">Change Password</h3>
              <button type="button" onClick={() => setOpen(false)} data-testid="change-password-close" className="text-white/60 hover:text-white">
                <X className="h-4 w-4" />
              </button>
            </div>
            <div className="space-y-4">
              {field('Current Password', current, setCurrent, 'current-password-input')}
              {field('New Password', next, setNext, 'new-password-input')}
              {field('Confirm New Password', confirm, setConfirm, 'confirm-password-input')}
              <button
                type="button"
                onClick={submit}
                disabled={busy}
                data-testid="change-password-submit"
                className="w-full bg-[#F5C542] py-2.5 text-xs font-semibold uppercase tracking-[0.2em] text-black hover:bg-[#FFDD75] disabled:opacity-50"
              >
                {busy ? 'Saving…' : 'Update Password'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
